__turbopack_context__.v({
  "ExpandButton": "joah8G_ExpandButton",
  "FirstOnLine": "joah8G_FirstOnLine",
  "IsAmongShown": "joah8G_IsAmongShown",
  "Item": "joah8G_Item",
  "ItemFirst": "joah8G_ItemFirst",
  "LastShown": "joah8G_LastShown",
  "List": "joah8G_List",
  "Root": "joah8G_Root",
  "Root--Collapsed": "joah8G_Root--Collapsed",
  "Root--Expanded": "joah8G_Root--Expanded",
  "Stack": "joah8G_Stack",
  "Tag": "joah8G_Tag",
  "Tag--Active": "joah8G_Tag--Active",
  "TagLabel": "joah8G_TagLabel",
  "skeleton-loading": "joah8G_skeleton-loading",
});
